



































import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import DataTable from '@/components/datatable/datatable';
import {CardForm} from '@/components/bwaff';
import {forEach} from 'lodash';
import moment from 'moment-timezone';
import { SecuritylApi } from '@/views/settings/security/api';
import { FormattersTypes } from '@/services/types/formatter';

@Component({
  components: {
    CardForm,
    DataTable
  }
})
export default class LatestSessions extends Vue {
  @Prop()
  api!: SecuritylApi;

  @Prop()
  dataSessions!: any;

  @Prop({ default:'DD MMM YYYY HH:mm' })
  format!: string;

  rows: any[] = [];
  rowsOnPage: number = 5;

  pagination: any = {
    rowsPerPage: this.rowsOnPage
  };

  formatters: any = {
    actions: ({ vtag, data }: FormattersTypes) => {
      const del = vtag(
        'a',
        {
          style: { color: 'var(--color-red)', 'font-size': '13px' },
          on: {
            click: (e: any) => {
              e.preventDefault();
              this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
                message: this.t('All selected items will be deleted permanently if you press OK.'),
                onConfirm: () => {
                  this.api.deleteSession(data.id).then(() => {
                    this.api.getSessions();
                    this.bus.emit('toast-success', this.t('The session has been successfully deleted'));
                  });
                },
              }})
            }
          }
        },
        [
          vtag(
            'ui-icon',
            {
              props: {
                size: 12,
                color: this.$colors.red,
                icon: 'fas fa-trash-alt',
              },
              style: {
                'margin-right': '4px',
                'vertical-align': 'baseline',
              }
            },
          ),
          this.t('Delete')
        ]
      );

      return vtag('td', { class: 'span-actions' }, [del]);
    }
  };

  @Watch('dataSessions')
  dataReceived(data: any = []) {
    this.rows = data;
    this.rows = forEach(data, e => {
      if(e.userIp) {
        let locationParts: string[] = [];

        if(e.country) {
          locationParts.push(e.country);
        }

        if(e.city) {
          locationParts.push(e.city);
        }

        let location = locationParts.length
          ? ` (${ locationParts.join(', ') })`
          : '';
        e.userIp = e.userIp + location;
      }

      e.actions = '';

      if(e.latestActivity){
        e.latestActivity =  moment.utc(e.latestActivity);
        e.latestActivity = e.latestActivity.tz(this.$store.state.user.defaultTimezone).format(this.format);
      }
      return e;
    });
  }

  get headers() {
    return [
      {
        text: this.t('Browser'),
        align: 'left',
        sortable: false,
        value: 'browser'
      },
      {
        text: 'IP',
        value: 'userIp',
        sortable: false
      },
      {
        text: this.t('Last Activity'),
        value: 'latestActivity',
        sortable: false
      },
      {
        align: 'right',
        value: 'actions',
        sortable: false
      }
    ];
  }

  submit() {
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: this.t('All selected items will be deleted permanently if you press OK.'),
      onConfirm: () => this.api.deleteSessions(),
    }})
  }
}
